import { ReactNode, useEffect } from 'react';

import { Splash } from '@/components';
import useAuth from '@/hooks/useAuth';

const PublicRoute = ({ element }: { element: ReactNode }) => {
  const { isLocalStorageUser, isLoading, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isLocalStorageUser && !isLoading) {
      /*
      Sospecho que esto es innecesario, no conozco cual
      es el bug que intenta corregir.
      */
      // eslint-disable-next-line no-console
      console.warn('PublicRoute, redirect a /');
      // window.location.href = ROUTES.basePath;
    }
  }, [isLocalStorageUser, isLoading]);

  if (isLoading && !isAuthenticated) {
    return <Splash />;
  }

  return element;
};

export default PublicRoute;
